'use strict';

var _require = require('lodash-es'),
    initial = _require.initial;

function activeStates() {
  var wrappers = document.querySelectorAll('.js-form-field');

  var _loop = function _loop(wrapper) {
    var input = wrapper.querySelector('input');

    input.onfocus = function () {
      input.parentNode.classList.add('active');
    };
    input.onblur = function () {
      input.parentNode.classList.remove('active');
    };

    input.addEventListener('keyup', function () {
      if (input.value && input.value.length > 0) {
        input.parentNode.classList.add('filled');
      } else {
        input.parentNode.classList.remove('filled');
      }
    });

    if (input.value && input.value.length > 0) {
      input.parentNode.classList.add('filled');
    } else {
      input.parentNode.classList.remove('filled');
    }
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = wrappers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var wrapper = _step.value;

      _loop(wrapper);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function updateCountry() {
  var countrySelectors = document.querySelectorAll('.js-address-country');

  if (countrySelectors.length > 0) {
    var _loop2 = function _loop2(country) {
      var form = country.closest('form');

      if (country.dataset.value) {
        country.value = country.dataset.value;
        updateProvince(country.dataset.value, form);
      } else {
        country.value = '';
      }

      country.addEventListener('change', function () {
        var newDatasetValue = country.querySelector('option[value="' + country.value + '"]');
        var newDatasetCountry = newDatasetValue.value;
        updateProvince(newDatasetCountry, form);
      });
    };

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = countrySelectors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var country = _step2.value;

        _loop2(country);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
}

function updateProvince(selectedCountry, form) {
  var country = form.querySelector('.js-address-country');
  var province = form.querySelector('.js-address-province');
  var provinceValue = province.dataset.value;
  var provincesData = country.querySelector('option[value="' + selectedCountry + '"]');
  var provinceContents = JSON.parse(provincesData.dataset.provinces);
  var provinceOptions = province.querySelectorAll('option');

  // Remove any old options
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = provinceOptions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var option = _step3.value;

      option.parentNode.removeChild(option);
    }

    // Add updated options
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = provinceContents[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var provinceOption = _step4.value;

      var key = provinceOption[0];
      var value = provinceOption[1];
      var _option = '<option value="' + key + '">' + value + '</option>';
      province.insertAdjacentHTML('beforeend', _option);
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  province.value = provinceValue;
}

function init() {
  activeStates();
  updateCountry();
}

init();